import { Building2, Clock } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { PortalData } from '@/types/portalCliente'
import { getStatusBadge } from '@/utils/portalClienteUtils'

export function PortalClienteHeader({ data }: { data: PortalData }) {
  const statusBadge = getStatusBadge(data.cliente.status)
  const empresaNome = data.empresa.nomeFantasia ?? data.empresa.razaoSocial ?? data.empresa.nome

  return (
    <header className="border-b border-white/[0.06] bg-[#0f0f1a]/80 backdrop-blur-xl sticky top-0 z-10">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center">
            <Building2 size={20} className="text-accent" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-white">{empresaNome}</h1>
            {data.empresa.cnpj && <p className="text-xs text-white/40">CNPJ: {data.empresa.cnpj}</p>}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {data.cliente.ultimoCheckIn && (
            <span className="flex items-center gap-1 text-[11px] text-white/40">
              <Clock size={11} />
              Check-in: {new Date(data.cliente.ultimoCheckIn).toLocaleDateString('pt-BR')}
            </span>
          )}
          <span className={cn('px-3 py-1 text-xs font-medium rounded-full border', statusBadge.className)}>
            {statusBadge.label}
          </span>
        </div>
      </div>
    </header>
  )
}
